import * as React from "react";

function RpiPrintIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 36 21"
    >
      <defs>
        <clipPath>
          <rect width="36" height="21" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-rpi-print)">
        <path
          data-name="Path 7075"
          d="M9.04,0,5.98-5.62H4.82V0H1.46V-14.16h5.4a9.378,9.378,0,0,1,1.99.21,5.173,5.173,0,0,1,1.74.71,3.714,3.714,0,0,1,1.23,1.32,4.122,4.122,0,0,1,.46,2.04,3.764,3.764,0,0,1-.78,2.42,4.254,4.254,0,0,1-2.16,1.4L13.04,0ZM8.9-9.82a1.418,1.418,0,0,0-.21-.81,1.439,1.439,0,0,0-.54-.48,2.346,2.346,0,0,0-.74-.23,5.458,5.458,0,0,0-.79-.06H4.8v3.3H6.42a5.47,5.47,0,0,0,.86-.07,2.74,2.74,0,0,0,.8-.25,1.527,1.527,0,0,0,.59-.52A1.541,1.541,0,0,0,8.9-9.82Zm17.56.02A4.344,4.344,0,0,1,26-7.71a3.779,3.779,0,0,1-1.24,1.37,5.473,5.473,0,0,1-1.8.76,9.226,9.226,0,0,1-2.12.24h-1.7V0H15.72V-14.16h5.2a9.759,9.759,0,0,1,2.17.23,5.117,5.117,0,0,1,1.76.74,3.586,3.586,0,0,1,1.18,1.34A4.421,4.421,0,0,1,26.46-9.8Zm-3.42.02a1.525,1.525,0,0,0-.2-.82,1.393,1.393,0,0,0-.54-.5,2.317,2.317,0,0,0-.77-.24,6.436,6.436,0,0,0-.89-.06h-1.5v3.34h1.44a5.136,5.136,0,0,0,.92-.08,2.47,2.47,0,0,0,.79-.28,1.5,1.5,0,0,0,.55-.53A1.578,1.578,0,0,0,23.04-9.78ZM29.52,0V-14.16h3.44V0Z"
          transform="translate(0 19)"
          fill="#a77add"
        />
      </g>
    </svg>
  );
}

export default RpiPrintIcon;
